import SEOHead from '../../components/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#business`,
        "name": "Master Jae Production",
        "image": "https://static.readdy.ai/image/03bed3920353e1c914a48979e0760637/58a2f24010e53db81b2c2c87fe73444e.png",
        "description": "Professional multimedia production studio offering music recording, mixing, mastering, graphic design, brand identity, and post production services in Tumahole, Parys, South Africa.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "8422 Mandela Section",
          "addressLocality": "Tumahole, Parys",
          "addressRegion": "Free State",
          "postalCode": "9585",
          "addressCountry": "ZA"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "-26.9036",
          "longitude": "27.4647"
        },
        "telephone": "+27817844091",
        "email": "masterjaemultimedialap@gmail.com",
        "url": siteUrl,
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Saturday",
            "opens": "10:00",
            "closes": "16:00"
          }
        ],
        "priceRange": "R350-R1000",
        "sameAs": [
          "https://web.facebook.com/profile.php?id=100054493058930"
        ],
        "areaServed": {
          "@type": "City",
          "name": "Parys"
        }
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "Master Jae Production",
        "description": "Professional Music Studio, Graphic Design & Post Production in Tumahole, Parys",
        "publisher": {
          "@id": `${siteUrl}/#business`
        }
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        "url": siteUrl,
        "name": "Master Jae Production | Professional Music Studio & Graphic Design in Tumahole, Parys",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${siteUrl}/#business`
        },
        "description": "Master Jae Production offers professional music studio services including recording, mixing, mastering, graphic design, brand identity, and post production in Tumahole, Parys, South Africa."
      },
      {
        "@type": "Service",
        "serviceType": "Music Studio Services",
        "provider": {
          "@id": `${siteUrl}/#business`
        },
        "areaServed": {
          "@type": "City",
          "name": "Parys"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Music Studio Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Recording & Mixing",
                "description": "Professional music recording and mixing services"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Mastering & Beats",
                "description": "Audio mastering and beat production"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Podcasts & Voiceovers",
                "description": "Podcast recording and voiceover services"
              }
            }
          ]
        }
      },
      {
        "@type": "Service",
        "serviceType": "Graphic Design Services",
        "provider": {
          "@id": `${siteUrl}/#business`
        },
        "areaServed": {
          "@type": "City",
          "name": "Parys"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Graphic Design Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Logo Design",
                "description": "Custom logo design and brand identity"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Brand Identity",
                "description": "Complete brand identity packages"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Social Media Graphics",
                "description": "Social media posts and marketing materials"
              }
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What music studio services does Master Jae Production offer in Tumahole, Parys?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Master Jae Production offers professional recording, mixing, mastering, beat production, podcasts, voiceovers, and vocal coaching services in our Tumahole, Parys studio."
            }
          },
          {
            "@type": "Question",
            "name": "How much does a recording session cost at Master Jae Production?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Studio sessions start at R350 per hour, which includes professional recording equipment, mixing, mastering, and a studio engineer."
            }
          },
          {
            "@type": "Question",
            "name": "Does Master Jae Production offer graphic design services?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer comprehensive graphic design services including logo design, brand identity, posters, flyers, social media posts, apparel artwork, and business cards starting from R250."
            }
          },
          {
            "@type": "Question",
            "name": "Where is Master Jae Production located?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Master Jae Production is located at 8422 Mandela Section, Tumahole, Parys, 9585, South Africa. Contact us at 081 784 4091 or masterjaemultimedialap@gmail.com."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Tumahole Parys Music Studio Master Jae Production | Recording Mixing Mastering Graphic Design"
        description="Master Jae Production offers professional music studio services including recording, mixing, mastering, graphic design, brand identity, and post production in Tumahole, Parys, South Africa. Book your session today at 081 784 4091. Your Vision, Professionally Crafted."
        keywords="music studio Parys, recording studio Tumahole, graphic design Parys, post production South Africa, Master Jae Production"
        canonical={`${siteUrl}/`}
        schema={schema}
      />
      <div className="bg-[#0a0f1c]">
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <Pricing />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
